import padStart from 'lodash/padStart';

import {
	lStorage,
	MIDNIGHT_SETTING,
	DAY_START_END_SETTING,
	SHORT_DATE_FORMAT_REGEX,
} from 'modules/utils';
import parse from 'date-fns/fp/parse';
import {
	DISPLAY_DATE_FORMAT,
	DEFAULT_SHORT_DATE_FORMAT_FNS,
} from '../constants/datetime';

// This will check if the current pathname module is allowed. Base on the modules the user
// has, if user is not restricted, he/she will be allowed to see all the modules. Being save
// in localStorage.
export const isPathNameAllowed = ({ pathname }) => {
	const { user } = lStorage.get({ key: 'current-user' });

	const { accessWhiteList, restrictedUser } = user;
	if (+restrictedUser === 0) {
		return true;
	}
	const splittedAccessList = accessWhiteList.split(',');
	const initialUrlName = pathname.split('/').filter(Boolean)[0];
	return splittedAccessList.includes(initialUrlName);
};

/**
 * Used together with the `parseLocationStartEndTime` function to split
 * the minutes and seconds out of a time string.
 *
 * @function
 * @param {string} time
 * @returns {Object}
 */
const splitHoursAndMinutes = time => {
	const parsedTime = padStart(time, 4, '0');

	return {
		hours: parsedTime.slice(0, 2),
		minutes: parsedTime.slice(2, 4),
		seconds: '00',
	};
};

/**
 * Parses the business' start/end time, which comes from the DB as a string.
 * Example format:
 *   - `0201`, meaning `02:01 AM`
 *   - `02`, meaning `00:02 AM`
 *
 * @function
 * @param {string} dayRollover
 * @param {string} time
 * @returns {string}
 */
export const parseLocationStartEndTime = (
	dayRollover = MIDNIGHT_SETTING,
	time
) => {
	if (dayRollover === MIDNIGHT_SETTING) {
		return '00:00:00';
	}

	if (dayRollover === DAY_START_END_SETTING) {
		const { hours, minutes, seconds } = splitHoursAndMinutes(time);

		return `${hours}:${minutes}:${seconds}`;
	}

	return '00:00:00';
};

/**
 * Function to parse a string date into a Date object, this is done because on the newer
 * versions of date-fns the support of string dates is removed
 *
 * @function
 * @param {string} datetime String date or datetime to parse
 * @param {string} format The format used by the string date, defaults to yyyy-MM-dd
 */
export const parseDateTime = (datetime, format = DISPLAY_DATE_FORMAT) =>
	parse(new Date())(format)(datetime);

/**
 * Function that given a specific date format it will return its short version.
 * i.e.
 * yyyy-MM-dd => MM-dd
 * dd/MM/yyyy => dd/MM
 * YYYY/MM/DD => MM/DD (regex is case insensitive)
 * @function
 * @param {string} dateFormat - The string date to exctract the short version from.
 *
 * @returns {string} -  The date's short version or a default value
 */
export const getShortDateFormat = dateFormat =>
	dateFormat
		? SHORT_DATE_FORMAT_REGEX.exec(dateFormat)
		: DEFAULT_SHORT_DATE_FORMAT_FNS;
